import toWebpImage from '@src/utils/to-webp-image';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
const pageLocalesData = getPageLocalesData();

function Lang() {
  if (getLanguageByPath() === 'zh-Hant') {
    return 'tc';
  } else {
    return getLanguageByPath();
  }
}
/**
 *  特装机甲数据
 */
export const mechaData = {
  basicInformation: pageLocalesData.mecha_unit.mecha_baseInfo_title,
  roleExperience: pageLocalesData.mecha_unit.tricera.driver_role_title,
  driverVoice: pageLocalesData.mecha_unit.driver_cv_title,
  mecha_story_tips: pageLocalesData.mecha_unit.mecha_story_title,
  manufacturer: pageLocalesData.mecha_unit.mecha_factory_title,
  // 鸣神特装机
  bg: toWebpImage(require(`./images/${Lang()}/bg.jpg`)),
  mecha_title_img: toWebpImage(require(`./images/${Lang()}/title.png`)),
  
  
  mechaName_img: toWebpImage(require(`./images/${Lang()}/mechaName.png`)),
  driverName_img: toWebpImage(require(`./images/${Lang()}/driverName.png`)),
  familyCrest_img: toWebpImage(require(`./images/${Lang()}/familyCrest.png`)),
  driverBg: toWebpImage(require(`./images/${Lang()}/bg-line-driver.png`)),
  mechaBg: toWebpImage(require(`./images/${Lang()}/bg-line-mecha.png`)),
  cvItemActive: toWebpImage(require(`./images/${Lang()}/cv-active-bg.png`)),
  cvItem: toWebpImage(require(`./images/${Lang()}/cv-bg.png`)),
  cvcvAudioPause: toWebpImage(require(`./images/${Lang()}/cv-pause.png`)),
  cvcvAudioPlay: toWebpImage(require(`./images/${Lang()}/cv-play.png`)),
  cvTabBox: toWebpImage(require(`./images/${Lang()}/cv-title-bg.png`)),
  cvTabBtnActive: toWebpImage(require(`./images/${Lang()}/cvTabBtnActive.png`)),
  cvTitleIcon: toWebpImage(require(`./images/${Lang()}/cvTitle-icon.png`)),
  driverActiveBtn: toWebpImage(require(`./images/${Lang()}/driver-active-btn.png`)),
  driverBtn: toWebpImage(require(`./images/${Lang()}/driver-btn.png`)),
  gotoTOPbg: toWebpImage(require(`./images/${Lang()}/gotoTOPbg.png`)),
  group_logo: toWebpImage(require(`./images/${Lang()}/group-logo.png`)),
  manufacturerIcon: toWebpImage(require(`./images/${Lang()}/manufacturer-icon.png`)),
  mechaActiveBtn: toWebpImage(require(`./images/${Lang()}/mecha-active-btn.png`)),
  mechaBtn: toWebpImage(require(`./images/${Lang()}/mecha-btn.png`)),
  returnBtn: toWebpImage(require(`./images/${Lang()}/returnBtn.png`)),
  titleIcon: toWebpImage(require(`./images/${Lang()}/title-icon.png`)),
  goTopBtn: toWebpImage(require(`./images/${Lang()}/top.png`)),
  triangle_icon: toWebpImage(require(`./images/${Lang()}/triangle-icon.png`)),
  triangleIcon: toWebpImage(require(`./images/${Lang()}/triangleIcon.png`)),
  
  videoBtn: toWebpImage(require(`./images/${Lang()}/video-btn.png`)),
  driver_sex: pageLocalesData.mecha_unit.tricera.driver_sex,
  driver_birth_place: pageLocalesData.mecha_unit.tricera.driver_birth_place,
  driver_mecha_name: pageLocalesData.mecha_unit.tricera.driver_mecha_name,
  driver_role_desc: pageLocalesData.mecha_unit.tricera.driver_role_desc,
  mecha_number: pageLocalesData.mecha_unit.tricera.mecha_number,
  mecha_head_height: pageLocalesData.mecha_unit.tricera.mecha_head_height,
  mecha_empty_weight: pageLocalesData.mecha_unit.tricera.mecha_empty_weight,
  mecha_full_weight: pageLocalesData.mecha_unit.tricera.mecha_full_weight,
  mecha_story_desc: pageLocalesData.mecha_unit.tricera.mecha_story_desc,
  mecha_factory_name: pageLocalesData.mecha_unit.tricera.mecha_factory_name,
  video_link:
    Lang() === 'ja'
      ? 'https://static-omni-mechabreak.seasungames.com/uploads/202507/1753500726126_FeiJing_PV_JP.mp4'
      : 'https://static-omni-mechabreak.seasungames.com/uploads/202507/1753500726126_FeiJing_PV_EN.mp4',
  zhCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/1762513140752_1CN-Vox_Pilot_Get_Elite_CharlesBell.wav',
      phrase: pageLocalesData.mecha_unit.tricera.phrase1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/1762513140752_2CN-Vox_Pilot_Entrance_Elite_CharlesBell_a.wav',
      phrase: pageLocalesData.mecha_unit.tricera.phrase2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/1762513140752_3CN-Vox_Pilot_MVP_Elite_CharlesBell_c.wav',
      phrase: pageLocalesData.mecha_unit.tricera.phrase3,
      isPlay: false
    }
  ],
  enCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/1762513083735_1EN-Vox_Pilot_Get_Elite_CharlesBell.wav',
      phrase: pageLocalesData.mecha_unit.tricera.phrase1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/1762513083735_2EN-Vox_Pilot_Entrance_Elite_CharlesBell_a.wav',
      phrase: pageLocalesData.mecha_unit.tricera.phrase2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/1762513083735_3EN-Vox_Pilot_MVP_Elite_CharlesBell_c.wav',
      phrase: pageLocalesData.mecha_unit.tricera.phrase3,
      isPlay: false
    }
  ],
  jaCvList: [
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/1762513114623_1JP-Vox_Pilot_Get_Elite_CharlesBell.wav',
      phrase: pageLocalesData.mecha_unit.tricera.phrase1,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/1762513114623_2JP-Vox_Pilot_Entrance_Elite_CharlesBell_a.wav',
      phrase: pageLocalesData.mecha_unit.tricera.phrase2,
      isPlay: false
    },
    {
      cvAudio_url: 'https://static-omni-mechabreak.seasungames.com/uploads/202511/1762513114624_3JP-Vox_Pilot_MVP_Elite_CharlesBell_c.wav',
      phrase: pageLocalesData.mecha_unit.tricera.phrase3,
      isPlay: false
    }
  ]


};
